document.addEventListener("DOMContentLoaded", function() {
  // Core elements
  const mainGallery = document.getElementById('main-gallery');
  const thumbnailsContainer = document.querySelector('.media-gallery-thumbnails');
  const thumbnails = document.querySelectorAll('.media-thumbnail');
  
  // Initialize state
  let galFlkty = null;
  let thumbnailFlkty = null;
  // Start on the selected variant's image (e.g. from ?variant= in the URL)
  let currentIndex = parseInt(mainGallery?.dataset.initialIndex, 10) || 0;
  let isMobile = window.innerWidth < 750;

  // Helper function to check if element exists
  const elementExists = (element) => element && element !== null;

  // Initialize Flickity for main gallery
  const initializeMainGallery = () => {
    if (!elementExists(mainGallery)) return;

    const flickityOptions = {
      pageDots: isMobile, // Show dots only on mobile
      prevNextButtons: true,
      cellAlign: 'left',
      adaptiveHeight: true,
      draggable: '>1',
      contain: true,
      wrapAround: true, // Enable infinite scrolling
      initialIndex: currentIndex,
      on: {
        ready: () => {
          console.log('Main gallery initialized');
          updateThumbnailsOnChange(currentIndex);
        },
        change: (index) => {
          console.log('Slide changed to:', index);
          currentIndex = index;
          updateThumbnailsOnChange(index);
        }
      }
    };

    try {
      galFlkty = new Flickity(mainGallery, flickityOptions);
      
      // Add keyboard navigation
      document.addEventListener('keydown', (e) => {
        if (!galFlkty) return;
        if (e.key === 'ArrowLeft') galFlkty.previous();
        if (e.key === 'ArrowRight') galFlkty.next();
      });
    } catch (error) {
      console.error('Error initializing main gallery:', error);
    }
  };

  // Initialize Flickity for thumbnails
  const initializeThumbnails = () => {
    if (!elementExists(thumbnailsContainer) || isMobile) return;

    const thumbnailOptions = {
      asNavFor: '#main-gallery',
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      cellAlign: 'left',
      groupCells: true,
      draggable: true
    };

    try {
      thumbnailFlkty = new Flickity(thumbnailsContainer, thumbnailOptions);
    } catch (error) {
      console.error('Error initializing thumbnails:', error);
    }
  };

  // Update thumbnails when main gallery changes
  const updateThumbnailsOnChange = (index) => {
    if (!elementExists(thumbnailsContainer)) return;
    
    // Remove active class from all thumbnails
    thumbnails.forEach(thumb => thumb.classList.remove('active'));
    
    // Add active class to current thumbnail
    if (thumbnails[index]) {
      thumbnails[index].classList.add('active');
      
      // Scroll thumbnail into view if needed
      if (thumbnailFlkty) {
        thumbnailFlkty.select(index);
      } else {
        thumbnails[index].scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    }
  };

  // Handle thumbnail clicks
  const setupThumbnailClicks = () => {
    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', (e) => {
        e.preventDefault();
        if (galFlkty) {
          galFlkty.select(index);
        }
        updateThumbnailsOnChange(index);
      });
    });
  };

  // Handle window resize
  const handleResize = () => {
    const wasInMobile = isMobile;
    isMobile = window.innerWidth < 750;

    // Check if we're crossing the mobile breakpoint
    if (wasInMobile !== isMobile) {
      // Destroy and reinitialize galleries
      if (galFlkty) {
        galFlkty.destroy();
        galFlkty = null;
      }
      if (thumbnailFlkty) {
        thumbnailFlkty.destroy();
        thumbnailFlkty = null;
      }
      
      // Reinitialize with new settings
      initializeMainGallery();
      initializeThumbnails();
      setupThumbnailClicks();
    }
  };

  // Handle lazy loading of images
  const setupLazyLoading = () => {
    const lazyImages = document.querySelectorAll('.media-image img[loading="lazy"]');
    
    if ('IntersectionObserver' in window) {
      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
            observer.unobserve(img);
          }
        });
      });

      lazyImages.forEach(img => imageObserver.observe(img));
    } else {
      // Fallback for browsers that don't support IntersectionObserver
      lazyImages.forEach(img => {
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
      });
    }
  };

  // Initialize everything
  const init = () => {
    initializeMainGallery();
    initializeThumbnails();
    setupThumbnailClicks();
    setupLazyLoading();

    // Add resize listener
    window.addEventListener('resize', debounce(handleResize, 250));
    
    // Add orientation change listener for mobile devices
    window.addEventListener('orientationchange', () => {
      setTimeout(() => {
        handleResize();
        if (galFlkty) galFlkty.resize();
        if (thumbnailFlkty) thumbnailFlkty.resize();
      }, 100);
    });
  };

  // Debounce helper function
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Start the initialization
  init();
});